import { StyledRTEContent } from "./styles";
import { sanitizeHtml } from "./utils";

interface RTEContentProps {
  content?: string | null;
}

export const RTEContent = ({ content }: RTEContentProps) => {
  const sanitizedContent = sanitizeHtml(content || "");

  if (sanitizedContent) {
    return (
      <StyledRTEContent
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    );
  }

  return null;
};
